import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import type { IconProps } from '@avodah-inc/types';
import { cn } from '@avodah-inc/ui/utils';

const exclamationVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type ExclamationProps = React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof exclamationVariants> &
  IconProps;

export const Exclamation = React.forwardRef<SVGSVGElement, ExclamationProps>(
  (
    {
      className,
      variant,
      viewBox,
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox={viewBox}
        fill={fill}
        className={cn(
          exclamationVariants({
            variant,
            className,
          }),
        )}
        ref={ref}
        {...props}
      >
        <path
          d="M10.0624 3.262C10.1052 3.18262 10.1687 3.11632 10.2462 3.0701C10.3237 3.02389 10.4122 2.99949 10.5024 2.99949C10.5926 2.99949 10.6811 3.02389 10.7586 3.0701C10.836 3.11632 10.8995 3.18262 10.9424 3.262L17.4424 15.262C17.4838 15.3382 17.5048 15.4239 17.5031 15.5107C17.5014 15.5974 17.4772 15.6822 17.4328 15.7568C17.3884 15.8313 17.3254 15.8931 17.2499 15.9359C17.1745 15.9787 17.0891 16.0011 17.0024 16.001H4.00037C3.91375 16.001 3.82859 15.9786 3.75326 15.9358C3.67793 15.8931 3.61499 15.8315 3.57063 15.757C3.52627 15.6826 3.502 15.598 3.5002 15.5114C3.49841 15.4248 3.51914 15.3392 3.56037 15.263L10.0624 3.262ZM11.8204 2.786C11.2534 1.738 9.75037 1.738 9.18337 2.786L2.68137 14.786C2.55751 15.0144 2.49511 15.2711 2.5003 15.5309C2.50548 15.7907 2.57807 16.0447 2.71094 16.268C2.84382 16.4913 3.03243 16.6763 3.25829 16.8048C3.48415 16.9333 3.73952 17.0009 3.99937 17.001H17.0024C17.2623 17.0011 17.5178 16.9336 17.7438 16.8052C17.9698 16.6767 18.1586 16.4918 18.2915 16.2685C18.4245 16.0451 18.4972 15.7911 18.5024 15.5312C18.5077 15.2713 18.4453 15.0145 18.3214 14.786L11.8214 2.786H11.8204ZM11.0004 7.5C11.0004 7.36739 10.9477 7.24021 10.8539 7.14645C10.7602 7.05268 10.633 7 10.5004 7C10.3678 7 10.2406 7.05268 10.1468 7.14645C10.0531 7.24021 10.0004 7.36739 10.0004 7.5V11.5C10.0004 11.6326 10.0531 11.7598 10.1468 11.8536C10.2406 11.9473 10.3678 12 10.5004 12C10.633 12 10.7602 11.9473 10.8539 11.8536C10.9477 11.7598 11.0004 11.6326 11.0004 11.5V7.5ZM11.2504 13.75C11.2504 13.9489 11.1714 14.1397 11.0307 14.2803C10.8901 14.421 10.6993 14.5 10.5004 14.5C10.3015 14.5 10.1107 14.421 9.97004 14.2803C9.82939 14.1397 9.75037 13.9489 9.75037 13.75C9.75037 13.5511 9.82939 13.3603 9.97004 13.2197C10.1107 13.079 10.3015 13 10.5004 13C10.6993 13 10.8901 13.079 11.0307 13.2197C11.1714 13.3603 11.2504 13.5511 11.2504 13.75Z"
          fill="#C0392B"
        />
      </svg>
    );
  },
);

Exclamation.displayName = 'Exclamation';
